import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import IconComment from '@/icons/Comment.svg';
import { useActivities } from '@/models/article';
import { ArticleWithRelations } from '@/models/request';

import { BaseMessageDetailedContent } from '../BaseMessage';

export const QualityControlMessage = ({ article }: { article: ArticleWithRelations }) => {
  const isLastQualityControlKO = article.steps?.findLast(
    (step) => step.status === 'cancelled' && step.step === 'quality-control'
  );

  const { data: { activities: qualityControlKOActivities } = { activities: [] } } = useActivities(
    {
      articleId: article.id,
      types: ['article_quality_control_completed'],
    },
    { enabled: !!isLastQualityControlKO }
  );

  const lastActivityQualityControlKO = qualityControlKOActivities[0];

  if (!lastActivityQualityControlKO) return null;

  const koNote = lastActivityQualityControlKO?.data?.koNote;
  const answerer = lastActivityQualityControlKO.data.answerer;
  let creatorName = lastActivityQualityControlKO.creator.name;

  if (creatorName && answerer) {
    creatorName += ` (${answerer})`;
  }

  return (
    <BaseMessageDetailedContent article={article}>
      <>
        <Stack>
          <Stack row gap="0.25rem" alignItems="center">
            <IconComment style={{ fontSize: '1.25rem', color: 'var(--color-warning-700)' }} />
            <p>
              <InlineText weight="medium">
                <Trans id="article.task.message-quality-control-ko-note">
                  Quality control note
                </Trans>
              </InlineText>
              {' • '}
              <Trans id="article.task.message-quality-control-ko-note.from">From</Trans>{' '}
              {creatorName}
            </p>
          </Stack>
          <Stack padding="0 0 0 0.25rem">"{koNote}"</Stack>
        </Stack>
      </>
    </BaseMessageDetailedContent>
  );
};
